import React from 'react';

// custom components
import { Title } from "_atoms";
import TimelineContainer from "./timeline-container";
import TimelineCard from "./timeline-card";
import TimelineAnalytics from "./timeline-analytics";

//bootstrap
import { Col, Row } from 'react-bootstrap';

const TimelineAnalyticsComponent = () => {
    return (
        <Row className="p-2">
            <Col>
                <Title subtitle={"Timeline Analytics"} description={"Show tasks analytics, Total, Complete, Rejected, Assigned"} />
            </Col>
            <TimelineContainer>
                <TimelineCard>
                    <TimelineAnalytics />
                </TimelineCard>
            </TimelineContainer>
        </Row>

    )
}

export default TimelineAnalyticsComponent
